async function fetchAllianceData({ queryKey }: { queryKey: string[] }): Promise<AllianceDataProps> {
    const allid = queryKey[1];

    if (!allid) return {};

    const res = await fetch(`${process.env.GATSBY_CC_GQL_URL}/graphql`, {
        method: 'POST',
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Method': 'POST',
            'Content-Type': 'application/json',
        },
        //  credentials: 'include',
        body: JSON.stringify({
            query: `
            query partnerAllianceInfo($allianceId: String!, $allidConfig: String, $allidGroupConfig: String) {
                partnerAllianceInfo(allianceId: $allianceId, allidConfig: $allidConfig, allidGroupConfig: $allidGroupConfig) {
                    allianceId
                    landingPageConfigs{
                      paramValue
                      pageType
                      paramKey
                    }
                    partnershipName
                    partnershipType
                    integrationType
                    lightModeHeader
                    segmentType
                    suppressEmailCapturePopup
                    allianceData {
                        allianceId
                        allianceInfo {
                            allianceLogo
                            allianceLargeLogo
                            allianceName
                            allianceCompanyUrl
                            alliancePhone
                            productLines
                            subCategory
                            tcpaDisclaimer
                            associatedPharmacyChainId
                            associatedPharmacyChainDisplayName
                            partnerId
                            partnerName
                            enableOutOfNetworkPopup
                            hasPreferredPharmacyFilter
                            turnOnPreferredPharmacyFilter
                        }
                        channel
                        partnerDisplayName
                        serviceHours
                        throttle
                    }
                }
            }
                `,
            variables: {
                allianceId: allid,
                allidConfig: allid,
                allidGroupConfig: '',
            },
        }),
    });

    if (!res.ok) {
        throw new Error(`call service for ${allid} fetch not ok`);
    }

    return res.json() as Promise<AllianceDataProps>;
}

export default fetchAllianceData;
